var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('default-template', [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [-1 < _vm.$route.path.indexOf('/center/notifications') ? _c('h2', {
    staticClass: "tit"
  }, [_vm._v("공지사항")]) : _vm._e(), -1 < _vm.$route.path.indexOf('/center/faqs') ? _c('h2', {
    staticClass: "tit"
  }, [_vm._v("자주묻는질문")]) : _vm._e(), -1 < _vm.$route.path.indexOf('/center/questions') ? _c('h2', {
    staticClass: "tit"
  }, [_vm._v("1:1 상담문의")]) : _vm._e()]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_vm._t("default")], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }